import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import KeystrokeInputableText from '@/components/keystrokeInputableText/KeystrokeInputableText.vue';
import PlbscfReadonlyValue from '@/components/plbscfReadonlyValue/PlbscfReadonlyValue.vue';
import PlbscfTableRow from '@/components/plbscfTableRow/PlbscfTableRow.vue';
import C決算期TableHeader from '@/components/決算期TableHeader/決算期TableHeader.vue';

import { InputableTextMixin } from '@/components/inputableText/InputableText';
import MoneyUnitLabelMixin from '@/entries/user/mixins/MoneyUnitLabelMixin';
import { PlbscfInputableTextId } from '@/entries/user/mixins/PlbscfKeystrokeInputableTextMixin';
import 計画三表TableMixin from '@/entries/user/mixins/計画三表TableMixin';

import AbstractPlbscfService, { PlbscfYearValue } from '@/classes/service/AbstractPlbscfService';
import Abstract計画PlbscfService from '@/classes/service/Abstract計画PlbscfService';
import { 月次推移, 月次推移ListItem } from '@/classes/service/モニタリング/差異分析Service';
import { ValueType } from '@/master/Plbscf';

export default mixins(MoneyUnitLabelMixin, InputableTextMixin, 計画三表TableMixin).extend({
  name: 'C差異分析MonthlyTable',

  components: {
    KeystrokeInputableText,
    PlbscfReadonlyValue,
    PlbscfTableRow,
    C決算期TableHeader,
  },

  props: {
    月次推移: {
      type: Object as PropType<月次推移>,
      required: true,
    },
    isReadonlyTable: {
      type: Boolean,
      default: false,
    },
    map: {
      type: Array as PropType<PlbscfInputableTextId[][]>,
      required: true,
    },
  },

  methods: {
    isNoValue(listItem: 月次推移ListItem): boolean {
      return listItem.config.valueType === ValueType.noValue;
    },
    has差異(listItem: 月次推移ListItem): boolean {
      return listItem.value?.差異 !== undefined;
    },
    isEditableMonth(listItem: 月次推移ListItem): boolean {
      return !this.isReadonlyTable && AbstractPlbscfService.isEditable(listItem.config, listItem.value!.実績);
    },
    getMonthlyValues(yv: PlbscfYearValue): number[] {
      return Abstract計画PlbscfService.getMonthlyValues(yv);
    },
  },
});
